import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import FormSection from "../../shared/component/form/FormSection";
import {toast} from "react-toastify";
import {STATUS, YESNO} from "../../shared/utils/Constants";
import {InputSwitch} from "primereact/inputswitch";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import {PhoneField} from "../../shared/component/form/PhoneField";
import AdminUserColumn from "../../shared/component/dataTable/columns/AdminUserColumn.json";
import AdminUserService from "../../shared/service/AdminUserService";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";
import CurrentUserService from "../../shared/service/CurrentUserService";
import '../../shared/styles/SettingsPage.css';
import '../../shared/styles/MasterDetailSave.css';

const defaultAdminUser = {
    id: '',
    userName: '',
    title:'MR',
    status: 'ACTIVE',
    group:"OWNER",
    mobilePhone: '',
    firstName: '',
    lastName: '',
    email: '',
    roles: [],
    branches: [],
    locked: 'N',
    password: '',
    wrongEntryNumbers: 0,
    superUser: false,
    activationDate: null,
    sendNotification: true,
    passwordChangeDate: null
};
export default class AdminUserSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            adminUserList: [],
            adminUser: defaultAdminUser,
            adminUserTemp: defaultAdminUser,
            adminUserDetailsSaveButtonRender: true,
            adminUserStatus: 'ACTIVE'
        }
        this.adminUserService = new AdminUserService();
        this.currentUserService = new CurrentUserService()
    }

    componentDidMount() {
        let obj1 = Object.assign({}, defaultAdminUser);
        let obj2 = Object.assign({}, defaultAdminUser);
        this.setState({
            adminUser: obj1, adminUserTemp: obj2, adminUserDetailsSaveButtonRender: false
        });
        this.refresh();

    }

    refresh() {
        this.adminUserService.findAllByGroupName("OWNER").then(response => this.setState({
            adminUserList: response
        }));
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm autocomplete="off">
                    <div className="settings-page__shell">
                        {this.adminUserDetails()}
                    </div>
                </AvForm>
            </div>
        );
    }

    setCheckedStatus = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.adminUser.userId)) {
            this.adminUserService.updateStatus(this.state.adminUser.userId, this.state.adminUserStatus)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            adminUser: response,
                            adminUserTemp: response,
                            adminUserDetailsSaveButtonRender: false
                        });
                        this.refresh();
                    }
                });
        } else {
            let adminUser = this.state.adminUser;
            adminUser["status"] = this.state.adminUser.status == "ACTIVE" ? "PASSIVE" : "ACTIVE";
            this.setState({adminUser: adminUser, adminUserTemp: adminUser});
        }

        return undefined;
    }

    showChangeStatusConfirmDialog = (value) => {
        let adminUserStatus = 'PASSIVE';
        if (value) {
            adminUserStatus = 'ACTIVE'
        }
        this.setState({
            displayShowStatusConfirmDialog: true,
            adminUserStatus: adminUserStatus,
            noticeResponse: "You are about to change the status. Are you sure?"
        });
    }

    adminUserDetails() {
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Admin Users</h1>
                </div>

                <div className="settings-page__panel master-detail-save">
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                                  onCancelClick={() => this.setState({displayShowDeleteConfirmDialog: false})}
                                  show={this.state.displayShowDeleteConfirmDialog}
                                  message={this.state.noticeResponse}/>
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.setCheckedStatus}
                                  onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                  show={this.state.displayShowStatusConfirmDialog}
                                  message={this.state.noticeResponse}/>

                    <div className="master-detail-save__split">
                        <div className="master-detail-save__list">
                            <FormSection title="Admin Users" className="master-detail-save__list-section">
                                <div className="settings-page__toolbar settings-page__toolbar--start master-detail-save__list-toolbar">
                                    <Button color="outline-primary" className="settings-page__btn--add" onClick={() => {
                                        this.addNew();
                                    }}>
                                        <i className="pi pi-plus" aria-hidden="true"/>
                                        <Translate contentKey="entity.action.add">Add</Translate>
                                    </Button>
                                </div>
                                <div className="settings-page__table-wrap master-detail-save__list-table">
                                    <DataTableAll ref={(elem) => this.refDataTable = elem} fields={AdminUserColumn.fields}
                                               objectName={AdminUserColumn.name}
                                               data={this.state.adminUserList}
                                               selectionMode="single" onDataSelect={this.onDataSelect}
                                               loading={this.state.loading}/>
                                </div>
                            </FormSection>
                        </div>

                        <div className="master-detail-save__details">
                            <div className="master-detail-save__details-body">
                                <FormSection title="Admin User Details">
                                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__filter-row--wide settings-page__form-fields">
                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="admin-user-status">Status</Label>
                                                <div className="settings-page__status-controls">
                                                    <AvField
                                                        id="admin-user-status"
                                                        type="select"
                                                        className="form-control"
                                                        name="status"
                                                        disabled={true}
                                                        value={this.state.adminUser.status}
                                                        onChange={this.__handleChange}>
                                                        {STATUS.map(element => (
                                                            <option value={element.value} key={element.value}>
                                                                {element.name}
                                                            </option>))}
                                                    </AvField>
                                                    <InputSwitch
                                                        checked={this.state.adminUser.status == "ACTIVE" ? true : false}
                                                        tooltip={"Change Status"}
                                                        disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                        onChange={(e) => this.showChangeStatusConfirmDialog(e.value)}/>
                                                </div>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="tradingName">
                                                    <Translate contentKey="adminUser.tradingName">Username</Translate>
                                                    <span style={{color: 'red'}}> (*)</span>
                                                </Label>
                                                <AvField
                                                    className="form-control"
                                                    name="userName"
                                                    id="adminUserName1"
                                                    disabled={!this.state.adminUserDetailsSaveButtonRender || !GeneralUtils.isNullOrEmpty(this.state.adminUser.userId)}
                                                    validate={{
                                                        maxLength: {
                                                            value: 255,
                                                            errorMessage: "You can enter up to 255 characters in this field."
                                                        }
                                                    }}
                                                    value={this.state.adminUser.userName}
                                                    onChange={this.__handleChange}/>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="lastName">
                                                    <Translate contentKey="adminUser.lastName">Password</Translate>
                                                </Label>
                                                <AvField
                                                    value={this.state.adminUser.password}
                                                    style={{webkitTextSecurity: "disc", textSecurity: "disc"}}
                                                    name="password"
                                                    type={"text"}
                                                    className="form-control"
                                                    disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                    onChange={this.__handleChange}/>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="emailAddress">
                                                    <Translate contentKey="adminUser.emailAddress">Email</Translate>
                                                    <span style={{color: 'red'}}> (*)</span>
                                                </Label>
                                                <AvField
                                                    type="email"
                                                    id="email1"
                                                    className="form-control"
                                                    name="email"
                                                    disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                    validate={{
                                                        minLength: {
                                                            "value": 5, "errorMessage": "Not Valid Email"
                                                        }, maxLength: {
                                                            value: 255,
                                                            errorMessage: "You can enter up to 255 characters in this field."
                                                        }
                                                    }}
                                                    value={this.state.adminUser.email}
                                                    onChange={this.__handleChange}/>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="firstName">
                                                    <Translate contentKey="adminUser.firstName">First Name</Translate>
                                                    <span style={{color: 'red'}}> (*)</span>
                                                </Label>
                                                <AvField
                                                    type="text"
                                                    className="form-control"
                                                    name="firstName"
                                                    disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                    validate={{
                                                        maxLength: {
                                                            value: 255,
                                                            errorMessage: "You can enter up to 255 characters in this field."
                                                        }
                                                    }}
                                                    value={this.state.adminUser.firstName}
                                                    onChange={this.__handleChange}/>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="lastName">
                                                    <Translate contentKey="adminUser.lastName">Last Name</Translate>
                                                    <span style={{color: 'red'}}> (*)</span>
                                                </Label>
                                                <AvField
                                                    type="text"
                                                    className="form-control"
                                                    name="lastName"
                                                    disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                    validate={{
                                                        maxLength: {
                                                            value: 255,
                                                            errorMessage: "You can enter up to 255 characters in this field."
                                                        }
                                                    }}
                                                    value={this.state.adminUser.lastName}
                                                    onChange={this.__handleChange}/>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="mobilePhone">
                                                    <Translate contentKey="contactManagement.mobilePhone">Mobile Phone</Translate>
                                                    <span style={{color: 'red'}}> (*)</span>
                                                </Label>
                                                <PhoneField kind={'mobile'}
                                                            disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                            name="mobilePhone" errorMessage="Not Valid Phone Number"
                                                            value={this.state.adminUser.mobilePhone}
                                                            onChange={this.__handleChange}/>
                                            </AvGroup>
                                        </div>

                                        <div className="settings-page__filter-field">
                                            <AvGroup>
                                                <Label for="lastName">
                                                    <Translate contentKey="merchantAccount.lastName">Send Notification?</Translate>
                                                </Label>
                                                <AvField
                                                    type="select"
                                                    className="form-control"
                                                    name="sendNotification"
                                                    disabled={!this.state.adminUserDetailsSaveButtonRender}
                                                    value={this.state.adminUser.sendNotification}
                                                    onChange={this.__handleChange}>
                                                    <option value='' key=''/>
                                                    {YESNO.map(element => (<option value={element.value} key={element.value}>
                                                        {element.name}
                                                    </option>))}
                                                </AvField>
                                            </AvGroup>
                                        </div>
                                    </div>
                                </FormSection>

                                <div className="settings-page__actions master-detail-save__form-actions">
                                    {this.state.adminUserDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.adminUser.userId) &&
                                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                            this.setState({adminUserDetailsSaveButtonRender: true});
                                        }}>
                                            <Translate contentKey="entity.action.add">Edit</Translate>
                                        </Button>}
                                    {this.state.adminUserDetailsSaveButtonRender &&
                                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                            this.saveAdminUser();
                                        }}>
                                            <Translate contentKey="entity.action.add">Save</Translate>
                                        </Button>}
                                    {this.state.adminUserDetailsSaveButtonRender &&
                                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                            let obj1 = this.state.adminUserTemp;
                                            this.setState({
                                                adminUser: Object.assign({}, obj1), adminUserDetailsSaveButtonRender: false
                                            });
                                        }}>
                                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                                        </Button>}
                                    {this.state.adminUserDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.adminUser.userId) &&
                                        <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                            this.showChangeDeleteConfirmDialog(true)
                                        }}>
                                            <Translate contentKey="entity.action.add">Delete</Translate>
                                        </Button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    showChangeDeleteConfirmDialog = (value) => {
        this.setState({
            displayShowDeleteConfirmDialog: true,
            noticeResponse: "Are you sure to delete?"
        });
    }

     delete = () => {
            if (!GeneralUtils.isNullOrEmpty(this.state.adminUser.userId)) {
                this.adminUserService.delete(this.state.adminUser.userId)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                           this.refresh();
                            let obj1 = Object.assign({}, defaultAdminUser);
                               let obj2 = Object.assign({}, defaultAdminUser);

                               this.setState({
                                   adminUser: obj1, adminUserTemp: obj2, adminUserDetailsSaveButtonRender: false
                               });
                        }
                    });
            }

            return undefined;
        }

    onDataSelect = (data) => {
        this.adminUserService.findById(data.userId).then(response => {
            this.setState({
                adminUser: Object.assign({}, response),
                adminUserTemp: Object.assign({}, response),
                adminUserDetailsSaveButtonRender: false
            });
        });
    }
    saveAdminUser = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.adminUser.userName) || GeneralUtils.isNullOrEmpty(this.state.adminUser.mobilePhone) || GeneralUtils.isNullOrEmpty(this.state.adminUser.firstName) || GeneralUtils.isNullOrEmpty(this.state.adminUser.lastName) || GeneralUtils.isNullOrEmpty(this.state.adminUser.email) ) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.adminUser.userId)) {
                this.state.adminUser["title"] = "MR";
                this.adminUserService.updateUser(this.state.adminUser.userId,this.state.adminUser)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                adminUserDetailsSaveButtonRender: false,
                                adminUser: Object.assign({}, response),
                                adminUserTemp: Object.assign({}, response)

                            });
                            this.refresh();
                        }
                    });
            } else {
                if (!GeneralUtils.isNullOrEmpty(this.state.adminUser.password) && !GeneralUtils.checkPasswordFormat(this.state.adminUser.password)) {
                    return toast.warn("Password must be at least one number, one lowercase letter, one uppercase letter, at least 8 characters");
                } else {
                    this.adminUserService.create(this.state.adminUser)
                        .then((response) => {
                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                this.setState({
                                    adminUserDetailsSaveButtonRender: false,
                                    adminUser: Object.assign({}, response),
                                    adminUserTemp: Object.assign({}, response)
                                });
                                this.refresh();
                            }
                        });
                }

            }
        }

    }

    addNew() {
        let obj1 = Object.assign({}, defaultAdminUser);
        let obj2 = Object.assign({}, defaultAdminUser);

        this.currentUserService.getCurrentAdminOrMemberUser().then(response => this.setState({
            adminUser: obj1, adminUserTemp: obj2, adminUserDetailsSaveButtonRender: true
        }));

    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let adminUser = this.state.adminUser;
        adminUser[e.target.name] = value;
        this.setState({adminUser: adminUser});
    }

}
